module.exports = __webpack_public_path__ + "static/whole-earth-discipline-7bc628624e9d83daaf6a853eaa5e35bd.jpg";